import { ApiService } from './ApiService';
import { Result, ResultOf } from '@/types/result';

/**
 * Ответ метода GetUpsellModalInfo (апселл после отмены, FINCH-2324)
 */
export interface UpsellModalInfoResponse {
    /** Нужно ли показать модалку */
    shouldShow: boolean;
    /** Ключ модалки — передать обратно в DismissUpsellModal */
    modalKey?: string;
}

/**
 * Ответ метода GetPackagesAnnouncementModalInfo (анонс пакетов 3/6/12 мес, FINCH-2446).
 * Повод один, поэтому ключ модалки клиенту не нужен — им владеет сервер.
 */
export interface PackagesAnnouncementModalInfoResponse {
    /** Нужно ли показать модалку */
    shouldShow: boolean;
}

/**
 * Ответ метода GetServiceOutageModalInfo (сбой в работе платформы, FINCH-2630).
 * Повод один, поэтому ключ модалки клиенту не нужен — им владеет сервер.
 */
export interface ServiceOutageModalInfoResponse {
    /** Нужно ли показать модалку */
    shouldShow: boolean;
}

/**
 * Ответ метода GetServiceRecoveryModalInfo («Восстанавливаем работу Finch», FINCH-2631).
 * Повод один, поэтому ключ модалки клиенту не нужен — им владеет сервер.
 */
export interface ServiceRecoveryModalInfoResponse {
    /** Нужно ли показать модалку */
    shouldShow: boolean;
}

/**
 * Модалки при входе поверх generic-реестра UserModalShown.
 */
export class UserModalsApi extends ApiService {
    base = 'UserModals';

    /**
     * Получить информацию о модалке апселла после отмены (FINCH-2324) для показа при входе
     */
    async getUpsellModalInfo(): Promise<ResultOf<UpsellModalInfoResponse>> {
        return await this.get(this.getUrl('GetUpsellModalInfo'));
    }

    /**
     * Пометить модалку апселла после отмены как показанную
     * @param modalKey Ключ модалки из getUpsellModalInfo
     */
    async dismissUpsellModal(modalKey: string): Promise<Result> {
        return await this.post(this.getUrl('DismissUpsellModal'), { modalKey });
    }

    /**
     * Получить информацию о модалке-анонсе запуска пакетов на 3/6/12 месяцев (FINCH-2446)
     */
    async getPackagesAnnouncementModalInfo(): Promise<ResultOf<PackagesAnnouncementModalInfoResponse>> {
        return await this.get(this.getUrl('GetPackagesAnnouncementModalInfo'));
    }

    /**
     * Пометить модалку-анонс запуска пакетов как показанную
     */
    async dismissPackagesAnnouncementModal(): Promise<Result> {
        return await this.post(this.getUrl('DismissPackagesAnnouncementModal'), {});
    }

    /**
     * Получить информацию о модалке о сбое в работе платформы (FINCH-2630).
     * Без редиректа на /Error при не-2xx: модалка информационная и не должна ронять страницу,
     * а ошибка превращается в failedResult — хост просто не покажет модалку.
     */
    async getServiceOutageModalInfo(): Promise<ResultOf<ServiceOutageModalInfoResponse>> {
        return await this.get(this.getUrl('GetServiceOutageModalInfo'), undefined, false);
    }

    /**
     * Пометить модалку о сбое как показанную
     */
    async dismissServiceOutageModal(): Promise<Result> {
        return await this.post(this.getUrl('DismissServiceOutageModal'), {});
    }

    /**
     * Получить информацию о модалке «Восстанавливаем работу Finch» (FINCH-2631).
     * Без редиректа на /Error при не-2xx — как у модалки о сбое.
     */
    async getServiceRecoveryModalInfo(): Promise<ResultOf<ServiceRecoveryModalInfoResponse>> {
        return await this.get(this.getUrl('GetServiceRecoveryModalInfo'), undefined, false);
    }

    /**
     * Пометить модалку «Восстанавливаем работу Finch» как показанную
     */
    async dismissServiceRecoveryModal(): Promise<Result> {
        return await this.post(this.getUrl('DismissServiceRecoveryModal'), {});
    }
}
